<template>
  <div class="cpt-sale-days">
    <div class="days-list" ref="day_panel">
      <div class="manual-padding"></div>
      <div 
        class="day-item"
        :class="{ 'active': activeDayIndex == index }" 
        :style="calcDateStyle(date, index)"
        v-for="date,index in timeList" 
        :key="index" 
        :ref="`day-${index}`" 
        @click="handleDateClick(index)"
      >
        <div class="start-date">{{ date.start_time | formatDate }}</div>
        <div class="sale-status">
          <div class="desc">{{ calcStatusDesc(date) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    curTime: {
      type: Number,
      default: 0
    },
    timeList: {
      type: Array, 
      default: () => [],
    },
    activeDayIndex: {
      type: Number,
      default: () => [],
    },
    cc: {
      type: Object,
      default: () => {},
    }
  },
  methods: {
    handleDateClick(index) {
      if(index == this.activeDayIndex) {
        return
      }
      this.$emit('update:activeDayIndex', index)
    },
    isOutdated(date) {
      return date.end_time < this.curTime
    },
    calcStatusDesc(date) {
      if(date.start_time < this.curTime && this.curTime < date.end_time) {
        return `正在秒杀`
      } else if (date.start_time > this.curTime) {
        return `即将开场`
      } else if (date.end_time < this.curTime) {
        return `秒杀结束`
      } else {
        return ''
      }
    },
    calcDateStyle(date, index) {
      return {
        color: this.cc.saleday_text_color,
        background: this.activeDayIndex == index ? this.calcGradientBg(this.cc.saleday_selected_bg) : (this.isOutdated(date) ? this.calcGradientBg(this.cc.saleday_outdate_bg) : this.calcGradientBg(this.cc.saleday_bg))
      }
    },
    calcGradientBg(str) {
      if(!str) {
        return ''
      }
      const colors = str.split(',')
      switch(colors.length) {
        case 1: 
          return colors[0]
        case 2: 
          return `linear-gradient(to bottom, ${colors[0]} 0%, ${colors[1]} 100%)`
        default:
          return str
      }
    }
  },
  filters: {
    formatDate(timestamp) {
      let date = new Date(timestamp * 1000)
      let month = date.getMonth() + 1
      let day = date.getDate() 
      return `${month}月${day}日`
    },
    
  }
};
</script>

<style lang="less" scoped>
.cpt-sale-days {
  height: 52px;
  width: 100%;
  .days-list {
    height: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .manual-padding {
      height: 40px;
      width: 12px;
      flex-shrink: 0;
    }
    .day-item {
      width: 67px;
      height: 40px;
      flex-shrink: 0;
      border-radius: 3px;
      background: rgba(255, 255, 255, 0.02);
      color: #FFF;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      &:last-child {
        margin-right: 12px;
      }
      // &.outdated {
      //   background: rgba(255, 255, 255, 0.2);
      // }
      // &.active {
      //   background: #FF6502;
      // }
      .start-date {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px; 
      }
      .sale-status {
        width: 100%;
        height: 11px;
        margin-top: 1px;
        position: relative;
        .desc {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0.5) ;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>